import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';
import buildPATHS from './paths';
import { applicationSentSelector } from '../store/selectors/appSelectors';

const GuardApplicationSent = ({ component: Component, path }) => {
  const applicationSent = useSelector(applicationSentSelector);

  const PATHS = buildPATHS();

  return (
    <Route
      exact
      path={path}
      render={(props) =>
        applicationSent ? <Component {...props} /> : <Redirect to={PATHS.login} />
      }
    />
  );
};

GuardApplicationSent.propTypes = {
  path: PropTypes.string.isRequired,
  component: PropTypes.elementType.isRequired,
};

export default GuardApplicationSent;
